import { Controller } from 'libraries/front-end-core/core/Router'
import getUrl from 'libraries/front-end-core/core/url'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { DEFAULT_FLAVOUR, LEGACY_FLAVOURS } from 'constants/flavours'
import { QA_MENU } from 'constants/controllers'
import Main from 'redux/containers/pages/qamenu/QAMenuContainer'
import Header from './Header'

export default new Controller({
  name: QA_MENU,
  route: 'qa(/:flavour)',
  controller (
    Router,
    {
      url: pageId,
      scrollMain,
      pageView,
      pageData = {},
      pageState = {},
      previousPageId,
      params: { flavour: _flavour = DEFAULT_FLAVOUR }
    },
    render
  ) {
    const [flavour, focusedAol] = _flavour.split('#')
    if (LEGACY_FLAVOURS.includes(flavour)) {
      return replaceUrl(
        getUrl(QA_MENU, { flavour: DEFAULT_FLAVOUR })
      )
    }

    render(
      { Main, Header },
      { flavour, focusedAol, searchType: 'qa', pageId },
      {
        bottleLink: flavour => getUrl(QA_MENU, { flavour }),
        flavour,
        pageId,
        pageView,
        searchType: 'qa'
      }
    )

    return pageId
  }
})
